module.exports = __webpack_public_path__ + "static/media/mars-red-moan.96c73f36.mp3";